var React = require('react');

function Subtract (props) {
    return React.createElement("svg",props,React.createElement("line",{"x1":"0.75","y1":"0.75","x2":"8.25","y2":"0.75","stroke":"#F4F5F5","strokeWidth":"1.5","strokeLinecap":"round"}));
}

Subtract.defaultProps = {"width":"9","height":"2","viewBox":"0 0 9 2","fill":"none"};

module.exports = Subtract;

Subtract.default = Subtract;
